// apiRoutes.js
// All paths are relative to the axios baseURL, which is `${REACT_APP_API_BASE_URL}/v2`
// (i.e. .../api/v2). So paths here mirror the V2 doc minus the `api/v2/` prefix.
const apiRoutes = {
  // ---- Auth (api/v2/auth) ----
  employeeLogin: 'auth/employee/login',
  refreshToken: 'auth/refresh',
  employeeLogout: 'auth/logout',
  changePassword: 'auth/me/change-password',

  // ---- Lookups (anonymous) ----
  getAllNationality: 'lookups/nationalities',
  getAllQualifications: 'lookups/qualifications',
  getExactSpecializations: 'lookups/specializations',

  // ---- Registration ----
  createAccount: 'employee/register',
  resetPassword: 'employee/reset-password',

  // ---- Profile (api/v2/employee) ----
  getEmployeeProfile: 'employee/profile',
  requestProfileUpdate: 'employee/profile-update-requests',
  getProfileUpdateRequest: 'employee/profile-update-requests',
  markProfileUpdateRequestRead: (requestId) =>
    `employee/profile-update-requests/${requestId}/mark-read`,

  // ---- Leader self-service (read-only) ----
  leader: {
    myPositions: 'employee/my-positions',
    mySubordinates: 'employee/my-subordinates',
  },

  // ---- Standards catalog (progressive / lazy) ----
  standards: {
    getMainStandards: 'standards',
    getSubStandards: (standardId) => `standards/${standardId}/sub-standards`,
    getItems: (subStandardId) => `sub-standards/${subStandardId}/items`,
    getItem: (itemId) => `items/${itemId}`,
  },

  // ---- Deposits ----
  getDepositForm: (itemId) => `deposit-form/${itemId}`,
  postNewDeposit: 'deposits',
  getAllAchievements: 'deposits',
  getDepositDetails: (depositId) => `deposits/${depositId}`,
  getArchiveDeposits: 'deposits/archive',
  getAccountStatement: 'account-statement',

  // ---- Evaluation (superior side + self) ----
  getSubordinateToEvaluate: 'evaluation/get-subordinates-to-evaluate',
  getEvaluationItems: (hierId) => `evaluation/get-evaluation-items/${hierId}`,
  getSubordinateEvaluation: (hierId) => `evaluation/get-subordinate-evaluation/${hierId}`,
  createEvaluation: (hierId) => `evaluation/create/${hierId}`,
  updateEvaluation: (hierId) => `evaluation/update/${hierId}`,
  getAllArchiveEvaluations: 'evaluation/get-all-archive-evaluations',
  getMyEvaluationDetails: (empEvalId) => `evaluation/my-evaluation-details/${empEvalId}`,
  getAllMyPastEvaluations: 'evaluation/get-all-past-evaluations',

  // ---- Annual evaluation (self) ----
  annualEvaluation: {
    myScores: (academicYearId) =>
      `annual-evaluation/my-scores?academicYearId=${academicYearId}`,
  },
  getAcademicYears: 'annual-evaluation/academic-years',

  // ---- Support ----
  supportMessages: {
    getAllMessagesSubject: 'support/message-types',
    sendMessage: 'support',
  },
};

export default apiRoutes;
